import React from 'react';
import { Link } from 'react-router-dom';
import Css from './Header.module.scss'

const Header = () => {
  return (
    <header className={Css.header}>
      <div className="container">
        <div className={Css.header_inner}>
          <div className={Css.brand}>
            <Link to="/">HiFair</Link>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header;